export const labelToName = (label: string) =>
  label
    .replace(/([a-zöäü])([A-ZÖÄÜ])/g, '$1_$2')
    .replace(/\s/g, '_')
    .toLowerCase()
    .replace(/ä/g, 'ae')
    .replace(/ü/g, 'ue')
    .replace(/ö/g, 'oe')
